﻿<script>
	import { pageNumber, model } from "../../stores";
	import { projectSettings, yesNoOptions } from "../../config";

	import QuestionsModel from "../../models/questionsModel";

	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NumberInput from "../../components/NumberInput.svelte";
	import Datepicker from "../../components/Datepicker.svelte";
	import TextInput from "../../components/TextInput.svelte";

	export let disabled = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let nextPageLabel = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;

	if (!disabled) {
		pageNumber.update((p) => pageIndex);
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		$model.Questions = new QuestionsModel();
		$model.Version = "2";
	}
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-sm-12">
			<h1 class="text-center">{projectSettings.classActionName}</h1>
		</div>
	</div>

	{#if $model.SurveyComplete == true}
		<p>
			You have previously submitted the Questionnaire, you are unable to complete this form again.
			<br />
			If you need to amend any of the details provided, please contact Shine Lawyers on <ClassActionPhoneNumber
			></ClassActionPhoneNumber> or via email to <ClassActionEmailAddress></ClassActionEmailAddress>.
		</p>

		<p>Yours sincerely,</p>
		<p>Shine Lawyers</p>
	{:else}
		<FormRow class="justify-content-md-center">
			<FormColumn>
				<h2 class="text-center">Questions relating to your COVID-19 Infection</h2>

				<p>
					In preparing for mediation Shine Lawyers are seeking to determine the potential value of group
					members individual claims. As part of this process, we require additional information from you about
					your injuries arising from the Ruby Princess Cruise.
				</p>
				<p>We appreciate you taking the time to fill out this further questionnaire.</p>
				<hr />
			</FormColumn>
		</FormRow>

		<form novalidate id="form-questionnaire">
			<h3>Contracting Covid-19</h3>
			<FormRow>
				<FormColumn>
					<label class:isrequired={required}>Did you contract Covid-19 from the Ruby Princess Cruise?</label>
					<RadioGroup
						name="contractedCovid"
						bind:value={$model.Questions.ContractedCovid}
						optionList={yesNoOptions}
						{required}
						{disabled}
					></RadioGroup>
				</FormColumn>
			</FormRow>

			{#if $model.Questions.ContractedCovid === "Yes"}
				<FormRow>
					<FormColumn>
						<label class:isrequired={required}>When was it diagnosed?</label>
						<Datepicker
							{disabled}
							required
							bind:formattedSelected={$model.Questions.CovidDiagnosedDate}
							id="covidDiagnosedDate"
							start={new Date(2020, 0, 1)}
							end={new Date()}
							placeholder="e.g. 01/05/2020"
							openOnClass="calendar-pop"
						/>
					</FormColumn>
				</FormRow>
			{/if}

			{#if $model.Questions.ContractedCovid != null}
				<br />
				<h3>Psychiatric Injury</h3>
				<FormRow>
					<FormColumn>
						<label class:isrequired={required}
							>Were you diagnosed with a psychiatric injury following the Cruise?</label
						>
						<RadioGroup
							name="psychiatricInjury"
							bind:value={$model.Questions.PsyciatricInjury}
							optionList={yesNoOptions}
							{required}
							{disabled}
						></RadioGroup>
					</FormColumn>
				</FormRow>

				{#if $model.Questions.PsyciatricInjury === "Yes"}
					<FormRow>
						<FormColumn>
							<label class:isrequired={required}>What was the diagnosis?</label>
							<TextInput
								id="psyciatricInjuryDiagnosis"
								bind:value={$model.Questions.PsyciatricInjuryDiagnosis}
								{required}
								{disabled}
							></TextInput>
						</FormColumn>
					</FormRow>
				{/if}
			{/if}

			{#if $model.Questions.ContractedCovid === "Yes"}
				<br />
				<h3>Treatment in Hospital</h3>
				<FormRow>
					<FormColumn>
						<label class:isrequired={required}
							>When you contracted COVID-19 following the Ruby Princess Cruise, were you hospitalised?
						</label>
						<RadioGroup
							name="IsHospitalised"
							bind:value={$model.Questions.IsHospitalised}
							optionList={yesNoOptions}
							{required}
							{disabled}
						></RadioGroup>
					</FormColumn>
				</FormRow>

				{#if $model.Questions.IsHospitalised == "Yes"}
					<FormRow>
						<FormColumn class="form-group col-md-12">
							<label class:isrequired={required} for="hospitalizedDays"
								>How many days in total were you hospitalized?</label
							>
							<NumberInput
								{required}
								{disabled}
								id="hospitalizedDays"
								bind:value={$model.Questions.HospitalizedDays}
								min="1"
							/>
						</FormColumn>
					</FormRow>

					<FormRow>
						<FormColumn class="form-group col-md-12">
							<label class:isrequired={required}
								>Were you admitted to the Intensive Care Unit (ICU)?</label
							>
							<RadioGroup
								name="admittedICU"
								bind:value={$model.Questions.AdmittedICU}
								optionList={yesNoOptions}
								{required}
								{disabled}
							></RadioGroup>
						</FormColumn>
					</FormRow>

					{#if $model.Questions.AdmittedICU == "Yes"}
						<FormRow>
							<FormColumn>
								<label class:isrequired={required}>How many days were you in ICU?</label>
								<NumberInput
									{required}
									{disabled}
									id="icuDays"
									bind:value={$model.Questions.IcuDays}
									min="1"
								/>
							</FormColumn>
						</FormRow>
					{/if}

					<FormRow>
						<FormColumn>
							<label class:isrequired={required}
								>Please provide details of what treatment you received in hospital? For example,
								intubation, oxygen.</label
							>
							<textarea
								rows="4"
								class="form-control"
								{required}
								{disabled}
								type="text"
								id="treatementType"
								name="treatementType"
								bind:value={$model.Questions.TreatementType}
							/>
						</FormColumn>
					</FormRow>
				{/if}

				<hr />

				<h3 style="margin-top:40px">COVID-19 Symptoms</h3>

				<FormRow class="form-row">
					<FormColumn class="form-group col-md-12">
						<label class:isrequired={required}
							>Please provide details of your symptoms arising from your COVID-19 infection, including
							identifying the symptom, its intensity, whether this reduced over time, and how long it
							lasted (including whether it is still ongoing).</label
						>
						<textarea
							rows="4"
							class="form-control"
							{required}
							{disabled}
							type="text"
							id="covidSymptoms"
							name="covidSymptoms"
							bind:value={$model.Questions.CovidSymptoms}
						/>
					</FormColumn>
				</FormRow>

				<FormRow class="form-row">
					<FormColumn class="form-group col-md-12">
						<label class:isrequired={required}>
							Did you receive any diagnosis regarding any ongoing symptoms?</label
						>
						<RadioGroup
							name="ongoingSymtptoms"
							bind:value={$model.Questions.OnGoingSymptoms}
							optionList={yesNoOptions}
							{required}
							{disabled}
						></RadioGroup>
						<div class="radio-error"></div>
					</FormColumn>
				</FormRow>

				{#if $model.Questions.OnGoingSymptoms == "Yes"}
					<FormRow>
						<FormColumn>
							<label class:isrequired={required}>Please provide details of the diagnosis.</label>
							<textarea
								rows="4"
								class="form-control"
								{required}
								{disabled}
								type="text"
								id="diagnosis"
								name="diagnosis"
								bind:value={$model.Questions.Diagnosis}
							/>
						</FormColumn>
					</FormRow>
				{/if}

				<FormRow>
					<FormColumn>
						<label class:isrequired={required}> Did these symptoms impact your day-to-day life.</label>
						<RadioGroup
							name="daytodayImpact"
							bind:value={$model.Questions.DayToDayImpact}
							optionList={yesNoOptions}
							{required}
							{disabled}
						></RadioGroup>
						<div class="radio-error"></div>
					</FormColumn>
				</FormRow>

				{#if $model.Questions.DayToDayImpact == "Yes"}
					<FormRow>
						<FormColumn>
							<label class:isrequired={required}
								>Please provide details of how your life was impacted, and for how long.</label
							>
							<textarea
								rows="4"
								class="form-control"
								{required}
								{disabled}
								type="text"
								id="impactDetail"
								name="impactDetail"
								bind:value={$model.Questions.ImpactDetail}
							/>
						</FormColumn>
					</FormRow>
				{/if}

				<FormRow>
					<FormColumn>
						<label class:isrequired={required}> Do you currently continue to exhibit any symptoms?</label>
						<RadioGroup
							name="continueSymptoms"
							bind:value={$model.Questions.ContinueSymptoms}
							optionList={yesNoOptions}
							{required}
							{disabled}
						></RadioGroup>
					</FormColumn>
				</FormRow>

				{#if $model.Questions.ContinueSymptoms == "Yes"}
					<FormRow>
						<FormColumn>
							<label class:isrequired={required}
								>When did you last experience any symptoms? If you had multiple symptoms which resolved
								at different times, please provide details of when each of the symptoms resolved.</label
							>
							<textarea
								rows="4"
								class="form-control"
								{required}
								{disabled}
								type="text"
								id="lastExperienceSymptoms"
								name="lastExperienceSymptoms"
								bind:value={$model.Questions.LastExperienceSymptoms}
							/>
						</FormColumn>
					</FormRow>
				{/if}

				<hr />

				<h3>Treatment of ongoing symptoms</h3>
				<FormRow>
					<FormColumn>
						<label class:isrequired={required}>Did you require ongoing treatment?</label>
						<RadioGroup
							name="requireOnGoingTreatment"
							bind:value={$model.Questions.RequireOnGoingTreatment}
							optionList={yesNoOptions}
							{required}
							{disabled}
						/>
					</FormColumn>
				</FormRow>

				{#if $model.Questions.RequireOnGoingTreatment == "Yes"}
					<FormRow>
						<FormColumn>
							<label class:isrequired={required}
								>What treatment did you undergo to treat any ongoing symptoms and for how long did this
								treatment last. Please indicate if the treatment is still ongoing.</label
							>
							<textarea
								rows="4"
								class="form-control"
								{required}
								{disabled}
								type="text"
								id="symptomsTreatment"
								name="symptomsTreatment"
								bind:value={$model.Questions.SymptomsTreatment}
							/>
						</FormColumn>
					</FormRow>
				{/if}

				<hr />

				<h3>Medical records</h3>
				<FormRow>
					<FormColumn>
						<label
							>For us to properly assess your claim, we may require access to your medical records.</label
						>
						<label class:isrequired={required}
							>Do you consent to us obtaining a copy of your medical records?</label
						>
						<RadioGroup
							name="consent"
							bind:value={$model.Questions.Consent}
							optionList={yesNoOptions}
							{required}
							{disabled}
						></RadioGroup>
					</FormColumn>
				</FormRow>

				{#if $model.Questions.Consent == "Yes"}
					<FormRow>
						<FormColumn>
							<label class:isrequired={required}
								>How many General Practitioners (GPs) treated you for your COVID-19 infection?</label
							>
							<NumberInput
								{required}
								{disabled}
								id="numberOfGP"
								bind:value={$model.Questions.NumberOfGP}
								min="1"
							/>
						</FormColumn>
					</FormRow>
				{/if}
			{/if}

			{#if !disabled}
				<FormRow>
					<FormColumn>
						<NavigationButtons {persistUrl} {nextPage} showPrevious={"false"}></NavigationButtons>
					</FormColumn>
				</FormRow>
			{/if}
		</form>
	{/if}
</PageSection>

<style>
</style>
